import { FC } from 'react';
import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
    DialogContent,
    DialogContentText,
    DialogActions,
    ConfirmButton,
    CancelButton,
    DialogPaperProps,
    CloseButtonContainer,
    DialogTitle
} from './styled';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
}

const ConfirmationDialog: FC<Props> = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel'
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description"
            PaperProps={DialogPaperProps}
        >
            <CloseButtonContainer>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: '#fff'
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </CloseButtonContainer>
            <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={onClose}>{cancelText}</CancelButton>
                <ConfirmButton onClick={onConfirm} autoFocus>
                    {confirmText}
                </ConfirmButton>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
